module.exports = __webpack_public_path__ + "static/media/image2.83946a45.JPG";